function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { sdkLogger } from '../../../logger';
import { createErrorLoggingObservable } from '../../../utils/observables/error-logging-observable';
import { InternalSessionState, FINAL_STATES, INITIAL_STATES } from '../internal-session-state';
import { checkIsManifestLinearType } from '../../../utils/playback-type';
// On slower networks / lower performance devices it can take a longer time to seek.
// The SEEKING_TOLERANCE_SECONDS is an added position margin that reduces the chance of falling out of the live window before seeking completes.
var SEEKING_TOLERANCE_SECONDS = 30;
// WINDOW_TOLERANCE_SECONDS is an added tolerance to detect user falling outside live widow early on. It will also be reported to the clients on top of the live start value
var WINDOW_TOLERANCE_SECONDS = 30;
// TWO_MINUTE_DVR_TOLERANCE_SECONDS is an added tolerance for 2m streams where the tolerance logic is disabled so that we avoid falling into Seeking-Playing bug when seeking to live start
var TWO_MINUTE_DVR_TOLERANCE_SECONDS = 30;
// Needed to disable tolerance logic for streams with less than two minutes DVR window
var TWO_MINUTE_DVR_WINDOW = 120;
// Prevent seeking if the range is smaller than this
var MIN_SEEKABLE_RANGE = 0.01;
export var SeekingManager = /*#__PURE__*/ function() {
    "use strict";
    function SeekingManager(advertsManager, isManifestLinearType, playerCapabilities, callSeekOnTimelineManager, onPlaybackTimelineUpdated, onStateChanged) {
        var _this = this;
        _class_call_check(this, SeekingManager);
        var _this1 = this;
        _define_property(this, "advertsManager", void 0);
        _define_property(this, "playerCapabilities", void 0);
        _define_property(this, "callSeekOnTimelineManager", void 0);
        _define_property(this, "onPlaybackTimelineUpdated", void 0);
        _define_property(this, "playerEngineItem", void 0);
        _define_property(this, "liveToleranceLogicEnabled", void 0);
        _define_property(this, "currentState", void 0);
        _define_property(this, "playbackTimeline", void 0);
        _define_property(this, "isSeekingToLiveStart", void 0);
        _define_property(this, "minWindowRecoveryDelayExceeded", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "seekStartedObservable", void 0);
        _define_property(this, "seekEndedObservable", void 0);
        _define_property(this, "_isSeeking", void 0);
        _define_property(this, "handleSeekStarted", void 0);
        _define_property(this, "handleSeekEnded", void 0);
        _define_property(this, "getLiveWindow", void 0);
        this.advertsManager = advertsManager;
        this.playerCapabilities = playerCapabilities;
        this.callSeekOnTimelineManager = callSeekOnTimelineManager;
        this.onPlaybackTimelineUpdated = onPlaybackTimelineUpdated;
        this.liveToleranceLogicEnabled = true;
        this.logger = sdkLogger.withContext('Seeking Manager');
        this.seekStartedObservable = createErrorLoggingObservable('SeekStarted', this.logger);
        this.seekEndedObservable = createErrorLoggingObservable('SeekEnded', this.logger);
        this._isSeeking = false;
        this.handleSeekStarted = function(timeIncludingAds) {
            var _this_playerEngineItem;
            _this._isSeeking = true;
            _this.advertsManager.handleSeekStarted(timeIncludingAds);
            var contentTime = _this.advertsManager.timeIncludingAdsToContentTime(timeIncludingAds);
            _this.seekStartedObservable.reset();
            _this.seekStartedObservable.notifyObservers(contentTime, _this.advertsManager.timeIncludingAdsToContentTime((_this_playerEngineItem = _this.playerEngineItem) === null || _this_playerEngineItem === void 0 ? void 0 : _this_playerEngineItem.getCurrentPosition()));
        };
        this.handleSeekEnded = function() {
            var _this_playerEngineItem;
            _this._isSeeking = false;
            _this.isSeekingToLiveStart = false;
            _this.minWindowRecoveryDelayExceeded = false;
            _this.seekEndedObservable.notifyObservers(undefined, _this.advertsManager.timeIncludingAdsToContentTime((_this_playerEngineItem = _this.playerEngineItem) === null || _this_playerEngineItem === void 0 ? void 0 : _this_playerEngineItem.getCurrentPosition()));
        };
        this.getLiveWindow = /*#__PURE__*/ _async_to_generator(function() {
            var _this_playerEngineItem;
            return _ts_generator(this, function(_state) {
                if (_this1.isBlockingUserInput()) {
                    _this1.logger.warn('SDK.SESSION.GET_LIVE_WINDOW.INVALID_STATE');
                    return [
                        2,
                        null
                    ];
                }
                return [
                    2,
                    ((_this_playerEngineItem = _this1.playerEngineItem) === null || _this_playerEngineItem === void 0 ? void 0 : _this_playerEngineItem.getLiveWindow()) || null
                ];
            });
        });
        onStateChanged(function(state) {
            _this.currentState = state;
        });
        this.onPlaybackTimelineUpdated(function(playbackTimeline) {
            _this.playbackTimeline = playbackTimeline;
            var seekableRange = _this.playbackTimeline.seekableRange;
            if (isManifestLinearType && _this.playerCapabilities.isLinearScrubbingSupported && !_this.playerCapabilities.isDvrWindowNativelyHandled && isSeekable(seekableRange)) {
                _this.avoidFallingOutsideLiveWindow();
            }
        });
    }
    _create_class(SeekingManager, [
        {
            key: "isSeeking",
            get: function get() {
                return this._isSeeking;
            }
        },
        {
            key: "setPlayerEngineItem",
            value: function setPlayerEngineItem(pei) {
                this.playerEngineItem = pei;
            }
        },
        {
            key: "adjustLiveWindow",
            value: function adjustLiveWindow(liveWindow) {
                // Please note the `liveWindow` object is only for our internal use to determine when
                // the user falls outside the actual live window but we use it to create the
                // value of the `seekableRange` which we surface to the client and it has our
                // added tolerance to it
                var modifiedSeekableRange = liveWindow;
                if (!liveWindow) {
                    return liveWindow;
                }
                if (this.playerCapabilities.isDvrWindowNativelyHandled || liveWindow.end - liveWindow.start <= TWO_MINUTE_DVR_WINDOW) {
                    this.liveToleranceLogicEnabled = false;
                }
                var startToleranceS = 0;
                if (this.liveToleranceLogicEnabled) {
                    startToleranceS = WINDOW_TOLERANCE_SECONDS + SEEKING_TOLERANCE_SECONDS;
                    // Adding Window Tolerance and Seeking Tolerance to the live start in the seekable range so we don't seek outside the live window and to reflect that on the UI for clients
                    modifiedSeekableRange = _object_spread_props(_object_spread({}, modifiedSeekableRange), {
                        start: liveWindow.start + startToleranceS
                    });
                }
                if (liveWindow === null || liveWindow === void 0 ? void 0 : liveWindow.startDate) {
                    var _liveWindow_startDate;
                    var startToleranceMs = startToleranceS * 1000;
                    var windowLengthMs = (modifiedSeekableRange.end - modifiedSeekableRange.start) * 1000;
                    modifiedSeekableRange.startDate = new Date(((_liveWindow_startDate = liveWindow.startDate) === null || _liveWindow_startDate === void 0 ? void 0 : _liveWindow_startDate.getTime()) + startToleranceMs);
                    modifiedSeekableRange.endDate = new Date(modifiedSeekableRange.startDate.getTime() + windowLengthMs);
                }
                return modifiedSeekableRange;
            }
        },
        {
            key: "avoidFallingOutsideLiveWindow",
            value: function avoidFallingOutsideLiveWindow() {
                if (!this.playbackTimeline) {
                    return;
                }
                var _this_playbackTimeline = this.playbackTimeline, position = _this_playbackTimeline.position, seekableRange = _this_playbackTimeline.seekableRange, liveWindow = _this_playbackTimeline.liveWindow;
                var adjustedLiveWindowStart = seekableRange === null || seekableRange === void 0 ? void 0 : seekableRange.start;
                if (liveWindow && this.liveToleranceLogicEnabled) {
                    adjustedLiveWindowStart = liveWindow.start + WINDOW_TOLERANCE_SECONDS;
                }
                if (this.currentState === InternalSessionState.Paused && !this.playerCapabilities.forcesLiveWindowRecoveryWhilePaused) {
                    return;
                } else if (this.isSeekingToLiveStart && this.minWindowRecoveryDelayExceeded) {
                    this.logger.warn("Seeking outside live window has exceeded the ".concat(SEEKING_TOLERANCE_SECONDS, " seconds timeout, firing seek again"));
                    this.manageFallingOutsideLiveWindow();
                } else if (!this.isSeekingToLiveStart && seekableRange && position <= adjustedLiveWindowStart) {
                    this.manageFallingOutsideLiveWindow();
                }
            }
        },
        {
            key: "seek",
            value: function seek(contentTime) {
                var _this_playerEngineItem;
                if (this.isBlockingUserInput()) {
                    this.logger.warn('SDK.SESSION.SEEK.INVALID_STATE');
                    return;
                }
                if (typeof contentTime !== 'number' || !isFinite(contentTime)) {
                    this.logger.error('Rejected attempt to seek to invalid time "'.concat(contentTime, '"'));
                    return;
                }
                if (!this.playbackTimeline) {
                    return;
                }
                // Please be aware that if the liveToleranceLogic is enabled, the Seekable
                // range at this point will already have both the window and seeking tolerances included
                // in it as this is done in the notifyLiveWindowUpdate function
                var seekableRange = this.playbackTimeline.seekableRange;
                if (!seekableRange) {
                    return;
                }
                var safeContentTime = this.getSafeContentTime(contentTime);
                if (safeContentTime !== contentTime) {
                    this.logger.warn("Position ".concat(contentTime, " is outside of seekable range (").concat(seekableRange.start, "-").concat(seekableRange.end, "), converting position to ").concat(safeContentTime));
                }
                var engineItemTime = this.advertsManager.contentTimeToTimeIncludingAds(safeContentTime);
                if (engineItemTime === ((_this_playerEngineItem = this.playerEngineItem) === null || _this_playerEngineItem === void 0 ? void 0 : _this_playerEngineItem.getCurrentPosition())) {
                    this.logger.warn('Attempted to seek to current position: "'.concat(engineItemTime, '"'));
                    return;
                }
                this.callSeekOnTimelineManager(engineItemTime);
            }
        },
        {
            key: "seekToAdjustedStartPosition",
            value: function seekToAdjustedStartPosition(contentTime) {
                var _this_playerEngineItem;
                var startPositionIncludingAds = this.advertsManager.contentTimeToTimeIncludingAds(contentTime);
                var managedStartPosition = this.advertsManager.manageStartPosition(startPositionIncludingAds);
                (_this_playerEngineItem = this.playerEngineItem) === null || _this_playerEngineItem === void 0 ? void 0 : _this_playerEngineItem.seek(managedStartPosition, true);
            }
        },
        {
            key: "onSeekStarted",
            value: function onSeekStarted(callback) {
                this.seekStartedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onSeekEnded",
            value: function onSeekEnded(callback) {
                this.seekEndedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "seekToLiveStart",
            value: function seekToLiveStart() {
                var _this = this;
                return _async_to_generator(function() {
                    var // TODO support seeking to event start of an SLE, as there maybe time
                    // between the start of the stream and the beginning of the content.
                    liveWindow, _liveWindow_startDate, seekTo;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getLiveWindow()
                                ];
                            case 1:
                                liveWindow = _state.sent();
                                if (liveWindow) {
                                    ;
                                    seekTo = _this.liveToleranceLogicEnabled ? liveWindow.start : liveWindow.start + TWO_MINUTE_DVR_TOLERANCE_SECONDS;
                                    if (((_liveWindow_startDate = liveWindow.startDate) === null || _liveWindow_startDate === void 0 ? void 0 : _liveWindow_startDate.getTime()) !== new Date(0).getTime()) {
                                        _this.seek(seekTo);
                                    }
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "seekToLiveEdge",
            value: function seekToLiveEdge() {
                var _this = this;
                return _async_to_generator(function() {
                    var liveWindow;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getLiveWindow()
                                ];
                            case 1:
                                liveWindow = _state.sent();
                                if (liveWindow) {
                                    _this.seek(liveWindow.end);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.seekStartedObservable.unregisterObservers(this);
                this.seekEndedObservable.unregisterObservers(this);
            }
        },
        {
            key: "getSafeContentTime",
            value: function getSafeContentTime(contentTime) {
                var seekableRange = this.playbackTimeline.seekableRange;
                var safeContentTime = Math.min(seekableRange.end, Math.max(seekableRange.start, contentTime));
                if (safeContentTime === seekableRange.end && !checkIsManifestLinearType(this.playerEngineItem.playoutData.type) && this.playerCapabilities.endOfStreamSeekTolerances && this.playerCapabilities.endOfStreamSeekTolerances[this.playerEngineItem.playoutData.type]) {
                    // On some devices, seeking into the exact last position causes playback issues. Adding a seeking tolerance can solve these issues.
                    // We do not apply tolerance to linear playback types to keep the latency correct.
                    return Math.floor(safeContentTime - this.playerCapabilities.endOfStreamSeekTolerances[this.playerEngineItem.playoutData.type]);
                }
                return safeContentTime;
            }
        },
        {
            key: "manageFallingOutsideLiveWindow",
            value: function manageFallingOutsideLiveWindow() {
                var _this = this;
                this.isSeekingToLiveStart = true;
                this.minWindowRecoveryDelayExceeded = false;
                setTimeout(function() {
                    // This is needed to avoid a `Seeking - Playing` loop bug on AAMP under poor bandwidth where
                    // by the time we seek to live start + the added tolerance we will be outside the live tolerance and
                    // AAMP's forcesLiveWindowRecoveryWhilePaused would kick in causing the bug to happen
                    _this.minWindowRecoveryDelayExceeded = true;
                }, WINDOW_TOLERANCE_SECONDS * 1000);
                this.logger.warn('Seekable range or current position are outside the live window, triggering Seek to live start');
                this.seekToLiveStart();
            }
        },
        {
            key: "isBlockingUserInput",
            value: function isBlockingUserInput() {
                return _to_consumable_array(INITIAL_STATES).concat(_to_consumable_array(FINAL_STATES)).includes(this.currentState);
            }
        }
    ]);
    return SeekingManager;
}();
function isSeekable(seekableRange) {
    if (!seekableRange) {
        return false;
    }
    return seekableRange.end - seekableRange.start > MIN_SEEKABLE_RANGE;
}

//# sourceMappingURL=seeking-manager.js.map